import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'src/Hooks/useQuery'
import { ProgressBarSteps } from 'src/Libs/shop/types'
import { SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM } from 'src/Libs/shop/consts'
import { NormalSystemConfigurationContext } from '../context/use-shop-normal-system-configuration-context'

interface NormalSystemConfigurationProviderProps {
  children: React.ReactNode
}
/*
 * Provides state and navigation logic for system configuration steps
 */
export const NormalSystemConfigurationProvider: React.FC<NormalSystemConfigurationProviderProps> = ({ children }) => {
  const query = useQuery()
  const navigate = useNavigate()
  const location = useLocation()

  const [activePage, setActivePage] = useState<number>(Number(query.get(SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM)) || ProgressBarSteps.BasicSystem)
  const [allowContinueMain, setAllowContinueMain] = useState<boolean>(false)

  const currentPage = query.get(SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM)

  const handleProgress = useCallback(
    (progress: ProgressBarSteps): void => {
      setActivePage(progress)
      navigate(location.pathname + `?${SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM}=${progress}`, { replace: true })
    },
    [navigate, location.pathname]
  )

  useEffect(() => {
    setActivePage(Number(currentPage) || ProgressBarSteps.BasicSystem)
  }, [currentPage])

  useEffect(() => {
    if (!currentPage) {
      navigate(location.pathname + `?${SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM}=${ProgressBarSteps.BasicSystem}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const contextValue = useMemo(
    () => ({
      activePage,
      setActivePage,
      handleProgress,
      allowContinueMain,
      setAllowContinueMain,
    }),
    [activePage, allowContinueMain, handleProgress]
  )

  return <NormalSystemConfigurationContext.Provider value={contextValue}>{children}</NormalSystemConfigurationContext.Provider>
}
